module.exports = __webpack_public_path__ + "static/media/9.8de9e1b6.jpg";